import clsx from 'clsx';
import { Box, styled, useMediaQuery } from '@mui/material';
import FusePageSimple from '@fuse/core/FusePageSimple';

export interface PageWrapperProps {
	className?: string;
	classes?: {
		root?: string;
		header?: string;
		toolbar?: string;
		content?: string;
	};
	header: React.ReactNode;
	toolbar?: React.ReactNode;
	content?: React.ReactNode;
	fab?: React.ReactNode;
	rightSidebarOpen?: boolean;
	setRightSidebarOpen?: (newValue: boolean) => void;
	rightSidebarContent?: React.ReactNode;
}

const PageWrapper = styled(
	({
		className,
		classes,
		header,
		toolbar,
		content,
		fab,
		rightSidebarOpen,
		setRightSidebarOpen,
		rightSidebarContent
	}: PageWrapperProps) => {
		const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'));
		const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

		const Header = (
			<>
				<Box className={clsx('PageWrapper-header', classes?.header)}>{header}</Box>
				<Box className={clsx('PageWrapper-toolbar', classes?.toolbar)}>{toolbar}</Box>
			</>
		);

		return (
			<Box className={clsx('h-full', className)}>
				<FusePageSimple
					className={classes?.root}
					header={Header}
					content={
						content ? (
							<Box className={clsx('PageWrapper-content', classes?.content)}>{content}</Box>
						) : undefined
					}
					// scroll={!isMobile ? 'content' : 'page'}
					scroll="page"
					rightSidebarOpen={rightSidebarOpen}
					rightSidebarOnClose={setRightSidebarOpen ? () => setRightSidebarOpen(false) : undefined}
					rightSidebarContent={rightSidebarContent}
					rightSidebarVariant={isDesktop ? 'permanent' : 'temporary'}
					rightSidebarWidth={400}
				/>
				{fab && <Box className="PageWrapper-fab">{fab}</Box>}
			</Box>
		);
	}
)(({ fab, rightSidebarOpen, theme, toolbar }) => ({
	'.FusePageSimple-wrapper': {
		// width: '100%'
	},
	'.FusePageSimple-contentWrapper': {
		display: 'flex',
		overflowY: 'auto'
	},
	'.FusePageSimple-header': {
		height: 'auto',
		minHeight: 'auto',
		padding: theme.spacing(2),
		paddingBottom: 0,
		'& > .container': {
			width: '100%'
		}
	},
	'.PageWrapper-header': {
		marginBottom: toolbar ? 8 : 0
	},
	'.PageWrapper-content': {
		width: '100%',
		padding: theme.spacing(2),
		paddingBottom: fab && !rightSidebarOpen ? theme.spacing(9) : theme.spacing(2),
		overflowY: 'overlay',
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(1),
			paddingBottom: fab && !rightSidebarOpen ? theme.spacing(9) : theme.spacing(1)
		}
	},
	'.PageWrapper-fab': {
		position: 'fixed',
		bottom: 0,
		right: 0,
		zIndex: 999,
		margin: 8
	},
	'.FusePageSimple-sidebar': {
		backgroundColor: 'transparent',
		zIndex: 1 // Default zIndex = 1200 causes the interactions (buttons, widgets, ...) in the dashboard to not work
	},
	'.FusePageSimple-sidebarContent': {
		paddingBottom: fab && rightSidebarOpen ? theme.spacing(9) : 0
	}
}));

export default PageWrapper;
